var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g2, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyArea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384,
    height: 215,
    viewBox: "0 0 384 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -212) translate(0 212) translate(99.357 21.483)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.865,
    cy: 87.121,
    r: 86.865,
    fill: "#F2F2F2",
    fillRule: "nonzero"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M73.929 156.138c1.89.28 3.197 2.043 2.916 3.934-.28 1.89-2.043 3.197-3.934 2.916-1.89-.28-3.197-2.043-2.916-3.934.28-1.89 2.043-3.197 3.934-2.916m.508-3.427c-.47-.07-.934-.088-1.39-.064l-.158 1.06c-.616.055-1.207.202-1.76.438l-.64-.86c-.42.197-.816.444-1.19.72-.372.277-.724.583-1.035.93l.638.86c-.386.462-.7.984-.932 1.558l-1.058-.157c-.157.429-.275.88-.345 1.35-.07.468-.088.934-.063 1.39l1.059.157c.055.617.204 1.208.438 1.762l-.86.638c.197.422.445.817.72 1.19.278.373.584.724.93 1.036l.862-.639c.46.387.983.7 1.556.933l-.157 1.06c.43.155.88.273 1.35.342.469.07.935.089 1.39.064l.158-1.06c.617-.055 1.207-.203 1.762-.438l.639.86c.421-.197.817-.444 1.189-.72.374-.276.724-.583 1.036-.929l-.64-.861c.388-.462.7-.984.933-1.558l1.06.158c.157-.43.273-.88.342-1.35.07-.47.09-.935.065-1.391l-1.06-.158c-.055-.616-.202-1.206-.439-1.761l.862-.638c-.199-.422-.444-.817-.721-1.19-.276-.373-.583-.724-.929-1.035l-.861.637c-.463-.386-.984-.699-1.558-.931l.157-1.06c-.429-.156-.88-.273-1.35-.343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M9.99 14.813c2.2.327 3.719 2.377 3.392 4.576-.326 2.199-2.376 3.718-4.575 3.392-2.2-.327-3.719-2.377-3.392-4.576.327-2.199 2.377-3.718 4.575-3.392m.592-3.985c-.546-.081-1.087-.103-1.618-.075l-.183 1.233c-.716.064-1.404.236-2.047.51l-.743-1.001c-.49.23-.95.516-1.385.838-.433.321-.842.678-1.204 1.08l.741 1.001c-.448.538-.813 1.145-1.083 1.813l-1.231-.183c-.183.499-.32 1.024-.4 1.57-.082.545-.103 1.087-.074 1.617l1.232.183c.064.718.237 1.404.51 2.049l-1 .742c.228.49.516.95.836 1.384.323.434.68.842 1.082 1.205l1.002-.743c.536.45 1.144.814 1.81 1.084l-.183 1.233c.5.181 1.024.318 1.57.398.546.082 1.088.104 1.618.075l.183-1.232c.718-.064 1.404-.237 2.049-.51l.743 1c.49-.229.95-.516 1.383-.838.435-.32.842-.678 1.205-1.08l-.743-1.002c.45-.537.813-1.144 1.084-1.811l1.233.183c.183-.5.317-1.024.398-1.57.082-.546.105-1.087.076-1.618l-1.234-.183c-.064-.717-.235-1.403-.51-2.049l1.002-.741c-.23-.492-.516-.951-.838-1.385-.32-.434-.678-.842-1.08-1.204l-1.002.742c-.538-.45-1.144-.814-1.812-1.084l.183-1.233c-.499-.18-1.024-.317-1.57-.398"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M10.263 85.707c-1.881.037-3.597-1.068-4.343-2.795-.745-1.727-.372-3.733.945-5.077 1.317-1.343 3.316-1.756 5.058-1.045 1.741.711 2.88 2.405 2.88 4.286 0 2.523-2.018 4.582-4.54 4.631zm0-6.855c-1.212 0-2.194.982-2.194 2.194s.982 2.194 2.194 2.194 2.194-.982 2.194-2.194-.982-2.194-2.194-2.194z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    fillRule: "nonzero",
    d: "M51.255 151.251H54.026V159.56300000000002H51.255z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M97.732 10.182H100.503V21.264000000000003H97.732z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    fillRule: "nonzero",
    d: "M48.485 154.022H56.797V156.79299999999998H48.485z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M93.576 14.338H104.65799999999999V17.108999999999998H93.576z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    fillRule: "nonzero",
    d: "M175.59 27.62H178.361V41.473H175.59z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    fillRule: "nonzero",
    d: "M170.049 33.162H183.90200000000002V35.933H170.049z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M34.615 150.119L76.323 131.536 59.918 24.134 18.195 42.718z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.173 107.582L16.465 126.165 0.045 18.764 41.768 0.18z",
    transform: "translate(18.15 23.954)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    fillRule: "nonzero",
    d: "M121.692 136.817L76.323 131.536 59.918 24.134 105.273 29.416z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M163.4 118.218L121.692 136.817 105.273 29.416 146.995 10.832z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    fillRule: "nonzero",
    d: "M106.241 35.696L60.871 30.415 26.11 45.911 40.608 140.737 75.369 125.24 120.724 130.522 155.485 115.04 141.002 20.215z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCCCC",
    fillRule: "nonzero",
    d: "M146.995 100.4L127.806 104.049 129.696 118.218 137.756 122.662 149.398 117.674z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M72.751 104.728L81.725 106.135 81.514 107.481 72.7 106.098 58.117 110.875 57.693 109.581 72.433 104.753zM52.146 34.055L71.426 45.799 70.717 46.962 51.437 35.219zM83.837 39.576L108.775 49.825 120.247 50.926 120.248 51.821 130.369 118.019 137.804 122.905 135.667 123.888 128.572 119.174 118.42 52.711 108.448 51.756 108.17 51.687 83.094 41.381z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M87.236 33.455L89.281 33.697 84.813 41.154 83.147 40.136zM110.68 33.697L127.78 40.818 127.257 42.076 108.98 34.414zM153.023 98.885L153.225 100.232 127.029 104.152 126.828 102.805z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M83.854 39.64L84.681 41.408 44.415 60.235 26.91 54.158 27.55 52.314 44.306 58.13z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.952,
    d: "M44.36 59.183l5.903 9.988c5.196 8.622 7.763 18.573 7.385 28.632l-1.392 36.124"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M105.732 49.045l1.2 1.541-7.953 6.194-1.335 1.067-1.1.865c-.625.485-1.092.833-1.398 1.033-2.348 1.332-4.9 2.265-7.553 2.76l-.726.125-6.993 1.07.417 4.35c.067.665.122 1.182.162 1.52l.043.335.143.954-13.153 2.121-12.828 4.512-.648-1.841 12.909-4.54.168-.043 11.364-1.835-.261-2.607-.426-4.576 8.805-1.35c2.677-.417 5.257-1.316 7.557-2.619l.207-.144c.166-.12.387-.285.653-.489l1.445-1.13 1.523-1.22 7.778-6.053z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M89.364 60.303L97.975 86.635 96.68 87.059 88.069 60.727z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.362,
    d: "M66.425 72.213L55.075 54.083M106.771 86.453L107.921 100.936 99.537 102.041"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M73.525 56.74L73.975 58.025 59.931 62.943 59.481 61.658z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M72.129 52.9L73.975 58.025 72.676 58.488 70.822 53.365zM137.608 21.719L133.732 40.398 137.756 66.75 121.93 69.168 121.636 67.238 135.531 65.116 131.748 40.342 135.063 22.811z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.952,
    d: "M33.752 95.927L43.135 96.018 46.419 111.408 57.587 110.637"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.362,
    d: "M43.816 101.738L57.36 101.118"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.952,
    d: "M49.158 67.507L32.875 73.242 30.226 72.864"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M148.06 100.4L150.811 117.128 149.565 117.674 146.717 100.625z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.952,
    d: "M127.806 110.939L118.091 114.465 90.548 115.691"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M57.774 99.368L70.579 94.065 90.623 94.899 90.903 126.927 88.951 126.944 88.686 96.772 70.925 96.033 58.521 101.172z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M79.985 106.173L81.347 106.171 81.363 119.66 72.063 120.464 71.828 127.307 70.466 127.26 70.744 119.211 79.999 118.411zM149.163 73.767L149.398 75.108 123.535 79.633 123.3 78.292zM154.66 109.4l.167 1.352-.82.106c-.615.082-1.23.168-1.803.253l-.99.156-.69.124c-.199.038-.363.074-.488.105l-.197.056-.451-1.286c.254-.089.695-.184 1.321-.294l.28-.048c.307-.051.646-.105 1.013-.16l1.206-.172 1.452-.191zM143.809 38.004L143.997 39.576 127.174 42.089 126.956 40.744z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M122.98 78.848l1.087 1.621-9.805 6.578-31.404.43-.972 15.692c-.148 2.188-.226 3.04-.301 3.332l-.027.083-1.784-.793.755-12.145.487-8.096 32.641-.448 9.323-6.254z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#E2E2E2",
    fillRule: "nonzero"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "nonzero",
    d: "M89.398 96.593L81.74 96.608 81.377 107.413 81.498 114.087 81.649 119.656 72.176 120.428 71.964 126.754 75.369 125.195 88.808 126.754z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "nonzero"
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0.409 29.488L14.891 124.314 49.652 108.817 35.17 14.007z",
    transform: "translate(25.717 16.393)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M36.473 32.347L53.283 121.092 94.249 101.385 77.065 6.996 35.906 26.77z",
    transform: "translate(25.717 16.393) scale(-1 1) rotate(19 0 -324.844)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    fillRule: "nonzero",
    d: "M148.266 10.832L164.741 120.163 163.4 118.218 146.995 10.832z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "M76.323 131.536L121.692 136.817 164.277 117.674 164.741 120.163 123.259 138.643 78.158 135.26 35.387 151.391 34.615 150.119z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    fillRule: "nonzero",
    d: "M123.327 151.285c-.045.011-.092.011-.137 0h.136z",
    opacity: 0.06
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF1B12",
    fillOpacity: 0.061,
    stroke: "#DF1B12",
    strokeDasharray: "1.385 4.156",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M95.314 100.4H70.822l-19.385 5.771L38.068 56.74l25.177-11.297 21.436 1.519-1.632 20.545 14.926 4.706-2.66 28.187z",
    transform: "translate(0 -212) translate(0 212) translate(99.357 21.483)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DCDBDB",
    d: "M13.53 13.755c42.896 7.477 65.794 11.414 68.694 11.81 4.35.595 6.572-3.747 4.297-5.747-.663-.583-3.994-.583-9.993 0l-56.612-8.852-11.63-1.19c-.439-.045-.832.275-.876.715-.036.346.157.676.477.815l5.644 2.45z",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.663,
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.312 0L.338 2.946c-.166.054-.277.209-.277.383 0 .175.111.33.277.384l12.107 5.569L13.312 0z",
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75) rotate(4 -13.35 22.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED2124",
    d: "M.278 3.713C.112 3.658 0 3.503 0 3.329c0-.174.112-.329.278-.383l2.542-.565 1.744-.368c-.48.687-.935 1.633-.546 3.253l.1.202-3.84-1.755z",
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75) rotate(4 -13.35 22.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFAFAF",
    d: "M66.636 14.905l-1.231-.14-1.473-.142-51.467-5.341c-.953-1.126-1.463-2.561-1.433-4.036-.136-2.007.734-3.95 2.32-5.185l50.983 5.3 2.825.283c-1.836-.182-2.542 9.14-.524 9.261z",
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75) rotate(4 -13.35 22.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M69.023 15.133l-2.683-.282c-.787 0-1.13-1.796-1.09-3.753 0-2.623.686-5.63 1.735-5.57l2.018.223h.726c-1.049 0-1.715 2.946-1.755 5.549 0 1.896.303 3.571 1.029 3.753l.02.08z",
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75) rotate(4 -13.35 22.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4C4C",
    d: "M68.357 15.073c-1.836-.141-1.19-9.443.646-9.322l2.744.282c-1.856-.12-2.502 9.181-.645 9.302l-2.745-.262z",
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75) rotate(4 -13.35 22.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M73.684 15.678l-2.704-.282c-1.816-.121-1.27-9.1.485-9.322l2.724.302c-1.796-.161-2.34 9.12-.505 9.302z",
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75) rotate(4 -13.35 22.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFAFAF",
    d: "M74.25 6.356c-.788 0-1.433 1.534-1.776 3.45-.464 2.563-.384 5.67.645 5.812l11.038.928c2.562.444 3.35-9.293.843-9.372l-10.75-.818z",
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75) rotate(4 -13.35 22.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M84.204 7.114c-1.693 1.402-2.114 7.334-.826 9.39l.779.042c2.562.444 3.35-9.293.843-9.372l-.796-.06z",
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75) rotate(4 -13.35 22.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M84.871 11.073c-.874 1.576-2.244 1.422-2.244 1.422-.028 1.605.211 3.147.751 4.008l.779.043c2.562.444 3.35-9.293.843-9.372.497 1.55.454 2.849-.129 3.9z",
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75) rotate(4 -13.35 22.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M73.24 15.622l10.138.881c-.47-.384-.78-2.578-.729-4.078L10.871 5.387.136 3.571 11.86 9l.726.343h.121l60.533 6.28z",
    opacity: 0.191,
    transform: "translate(0 -212) translate(0 212) translate(178.848 161.75) rotate(4 -13.35 22.579)"
  }))))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E5E5",
    d: "M248.754 42.747L254.184 40.28 265.475 140.413 264.098 141.645z",
    transform: "translate(0 -212) translate(0 212)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF1B12",
    fillOpacity: 0.061,
    stroke: "#DF1B12",
    strokeDasharray: "1.385 4.156",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M233.758 102.93c7.372-3.129 11.336-10.405 8.854-16.251-2.481-5.847-10.469-8.05-17.84-4.92-7.372 3.129-11.336 10.405-8.854 16.251 2.481 5.846 10.469 8.05 17.84 4.92z",
    transform: "translate(0 -212) translate(0 212)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyArea);
export default __webpack_public_path__ + "static/media/empty-area.71f1ba91f2bca96cd3a11b4c445cb960.svg";
export { ForwardRef as ReactComponent };